module.exports = __webpack_public_path__ + "static/images/eva-like.6fec4e7.png";